var map = {
	"./MDB Pro 4.4.3/js/modules (optional)/dropdown": 850
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 849;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/vendor ^\.\/MDB Pro .*\/js\/modules \(optional\)\/dropdown$
// module id = 849
// module chunks = 0